import React, {Component} from 'react';
//import MaterialIcon from '../../MaterialIcon';
import {connect} from "react-redux";
import {hideModal} from "../../../actions/nodeEditorPanelActions";
import {clickedNodeAction} from "../../../actions/clickedNodeActions";
import MultiplePropertyContent from "../components/MultiplePropertyContent";
import DynamicPropertyInput from "../components/DynamicPropertyInput";
//import InputWithLabel from "../components/InputWithLabel";
import PanelLayout from "../components/PanelLayout";

class DynamicPropertyPanel extends Component {

    constructor(props) {
        super(props);

        this.hasOptions = this.props.clickedNodeInfo.extras.options && this.props.clickedNodeInfo.extras.options.dynamicPropertyOptions;
        this.hasPredicate = this.hasOptions && this.props.clickedNodeInfo.extras.options.dynamicPropertyOptions.predicate;
        this.hasPValues = this.hasOptions && this.props.clickedNodeInfo.extras.options.dynamicPropertyOptions.pValueAsDynamicProperties;
        this.hasJsExpressions = this.hasOptions && this.props.clickedNodeInfo.extras.options.dynamicPropertyOptions.jsExpressions;
        this.hasDynamicProperties = this.hasOptions && this.props.clickedNodeInfo.extras.options.dynamicPropertyOptions.dynamicProperties;

        this.state = {
            pValueAsDynamicProperties: this.hasPValues ? this.props.clickedNodeInfo.extras.options.dynamicPropertyOptions.pValueAsDynamicProperties : [],
            dynamicProperties: this.hasDynamicProperties ? this.props.clickedNodeInfo.extras.options.dynamicPropertyOptions.dynamicProperties : [],
            doPredicate: !!this.hasPredicate
        };
        this.onTogglePredicate = this.onTogglePredicate.bind(this);
        this.onAddNewPValueProperty = this.onAddNewPValueProperty.bind(this);
        this.onAddNewJsExpression = this.onAddNewJsExpression.bind(this);
        this.onAddNewDynamicProperty = this.onAddNewDynamicProperty.bind(this);
        this.onDeleteProperty = this.onDeleteProperty.bind(this);
        this.onPropertyUpdate = this.onPropertyUpdate.bind(this);
    }

    componentDidMount() {
        const clickedNodeInfo = this.props.clickedNodeInfo;
        let dynamicPropertyInfo = Object.assign({}, clickedNodeInfo);
        if (!Object.prototype.hasOwnProperty.call(dynamicPropertyInfo.extras, "options")) {
            dynamicPropertyInfo.extras.options = {};
            this.props.clickedNodeAction(dynamicPropertyInfo);
        }
    }

    onTogglePredicate() {
        if (this.state.doPredicate) {
            this.setState({
                doPredicate: false
            }, this.onOptionsUpdate("predicate", undefined))
        } else {
            this.setState({
                doPredicate: true
            })
        }
    }

    onOptionsUpdate(type, value) {
        const clickedNodeInfo = this.props.clickedNodeInfo;
        let dynamicPropertyInfo = Object.assign({}, clickedNodeInfo);
        if (!Object.prototype.hasOwnProperty.call(dynamicPropertyInfo.extras, "options")) {
            dynamicPropertyInfo.extras.options = {};
        }

        dynamicPropertyInfo.extras.options.dynamicPropertyOptions = {
            ...dynamicPropertyInfo.extras.options.dynamicPropertyOptions,
            [type]: value
        }

        this.props.clickedNodeAction(dynamicPropertyInfo);
    }

    onDeleteProperty(propertyName, index) {
        const propertyUpdate = this.state[propertyName].filter((value, _index) => _index !== index);
        this.setState({
            [propertyName]: propertyUpdate
        }, () => this.onOptionsUpdate(propertyName, this.state[propertyName]));
    }

    onPropertyUpdate(propertyName, index, value) {
        let propertyUpdate = this.state[propertyName];
        propertyUpdate[index] = value;
        this.setState({
            [propertyName]: propertyUpdate
        }, () => this.onOptionsUpdate(propertyName, this.state[propertyName]));
    }

    onPValuePropertyChange(index, type, value) {
        let pValueAsDynamicProperties = this.state.pValueAsDynamicProperties;
        pValueAsDynamicProperties[index][type] = value;
        this.setState(({
            pValueAsDynamicProperties
        }), () => this.onOptionsUpdate("pValueAsDynamicProperties", this.state.pValueAsDynamicProperties));
    }

    onAddNewJsExpression() {
        this.setState(prevState => ({
            jsExpressions: [
                ...prevState.jsExpressions,
                ""
            ]
        }), () => this.onOptionsUpdate("jsExpressions", this.state.jsExpressions));
    }

    onAddNewDynamicProperty() {
        this.setState(prevState => ({
            dynamicProperties: [
                ...prevState.dynamicProperties,
                {type: "contextProperty", value: "itemId"}
            ]
        }), () => this.onOptionsUpdate("dynamicProperties", this.state.dynamicProperties));
    }

    onAddNewPValueProperty() {
        this.setState(prevState => ({
            pValueAsDynamicProperties: [
                ...prevState.pValueAsDynamicProperties,
                {
                    name: "",
                    significantDigit: 1
                }
            ]
        }), () => this.onOptionsUpdate("pValueAsDynamicProperties", this.state.pValueAsDynamicProperties));
    }

    render() {
        return (
            <PanelLayout>

                {/* P value Options

                <MultiplePropertyContent label="P Value As Dynamic Properties"
                                         onAddNew={this.onAddNewPValueProperty}>
                    {this.state.pValueAsDynamicProperties && this.state.pValueAsDynamicProperties.map((pValueDyn, index) => (
                        <div className="prop-row" key={index}>
                            <div className="p-value-row">
                                <div className="dyn-name">
                                    <InputWithLabel label="Dynamic Property Name"
                                                    value={this.state.pValueAsDynamicProperties[index].name}
                                                    handleChange={(e) => this.onPValuePropertyChange(index, "name", e.target.value)}/>
                                </div>
                                <div className="significant-digits">
                                    <InputWithLabel label="Significant Digits"
                                                    type="number"
                                                    value={this.state.pValueAsDynamicProperties[index].significantDigit}
                                                    handleChange={(e) => this.onPValuePropertyChange(index, "significantDigit", e.target.value)}/>
                                </div>

                            </div>
                            <div className="close-button"
                                 onClick={() => this.onDeleteProperty("pValueAsDynamicProperties", index)}>
                                <MaterialIcon icon="remove_circle"/>
                            </div>
                        </div>
                    ))}
                </MultiplePropertyContent>


                */}



                {/* Dynamic Property Options */}
                <MultiplePropertyContent label="Dynamic Property" onAddNew={this.onAddNewDynamicProperty}>
                    {this.state.dynamicProperties && this.state.dynamicProperties.map((dynProp, index) => (
                        <DynamicPropertyInput key={index} {...dynProp}
                                              updateDynamicProperty={(value) => this.onPropertyUpdate("dynamicProperties", index, value)}
                                              onDelete={() => this.onDeleteProperty("dynamicProperties", index)}/>
                    ))}
                </MultiplePropertyContent>

            </PanelLayout>
        )
    }
}

function mapStateToProps(state) {
    return {
        content: state.modalInfo.content,
        node: state.modalInfo.node,
        clickedNodeInfo: state.clickedNodeInfo
    }
}

export default connect(mapStateToProps, {hideModal, clickedNodeAction})(DynamicPropertyPanel);
